import React from 'react'
import classnames from 'classnames'
import styles from './user.module.scss'

type SocialType = 'twitter' | 'facebook' | 'instagram' | 'youtube' | 'website'

const icons = {
  twitter: 'solicon-twitter-alt',
  facebook: 'solicon-facebook',
  instagram: 'solicon-instagram',
  youtube: 'solicon-youtube',
  website: 'solicon-website',
}

const labels = {
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'Youtube',
  website: 'Website',
}

const getHref = (type: SocialType, value: string) => {
  switch (type) {
    case 'twitter':
      return `https://twitter.com/${value}`
    case 'facebook':
      return `https://www.facebook.com/${value}`
    case 'instagram':
      return `https://www.instagram.com/${value}`
    case 'youtube':
      return `https://youtube.com/channel/${value}`
    case 'website':
    default:
      return toSafeUrl(value)
  }
}

// ユーザー入力の URL は http(s) だけを許可する（javascript: などによる XSS 対策）。
// http(s):// で始まらなければ https:// を補う（javascript:... はホスト名として解釈され安全な URL になるか、パースに失敗する）
const toSafeUrl = (value: string) => {
  const url = /^https?:\/\//i.test(value) ? value : `https://${value}`
  try {
    const { protocol } = new URL(url)
    return protocol === 'https:' || protocol === 'http:' ? url : null
  }
  catch {
    return null
  }
}

interface Props {
  type: SocialType
  value: string
}

const SocialButton = ({ type, value }: Props) => {
  if (!value) {
    return null
  }

  const className = classnames(styles.btn, {
    [styles.twitter]: type === 'twitter',
    [styles.facebook]: type === 'facebook',
    [styles.instagram]: type === 'instagram',
    [styles.youtube]: type === 'youtube',
    [styles.website]: type === 'website',
  })
  const href = getHref(type, value)
  if (!href) {
    return null
  }

  return (
    <div className={styles.socialItem}>
      <a
        className={className}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className={icons[type]} />
        <span className={`tx-oswald tx-w800 tx-12 ${styles.socialText}`}>
          {labels[type]}
        </span>
      </a>
    </div>
  )
}

export default SocialButton
